import React from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Button, Grid } from '@mui/material';

export type OrderBackNextButtonsProps = {
    onBack?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    onNext: (event: React.MouseEvent<HTMLButtonElement>) => void;
    nextDisabled?: boolean;
    backDisabled?: boolean;
    hideBack?: boolean;
    hideNext?: boolean;
    backLabel?: string;
    nextLabel?: string;
    backAriaLabel?: string;
    nextAriaLabel?: string;
};

export const OrderBackNextButtons: React.FC<OrderBackNextButtonsProps> = (props) => {
    const backLabel = props.backLabel ?? '戻る';
    const nextLabel = props.nextLabel ?? '次へ';
    const backAriaLabel = props.backAriaLabel ?? backLabel;
    const nextAriaLabel = props.nextAriaLabel ?? nextLabel;
    const hideBack = props.hideBack ?? false;
    const hideNext = props.hideNext ?? false;
    const singleButton = (hideBack && !hideNext) || (!hideBack && hideNext);

    return (
        <Grid item container spacing={2} xs={11} sm={11} mb={1}>
            {!hideBack && (
                <Grid item xs={singleButton ? 12 : 6}>
                    <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<ArrowBackIosIcon fontSize="small" />}
                        onClick={props.onBack}
                        aria-label={backAriaLabel}
                        disabled={props.backDisabled}
                        sx={{
                            borderColor: 'grey.300',
                            color: 'primary.main',
                            py: 2,
                            borderRadius: 2,
                            fontWeight: 'bold',
                            bgcolor: 'white'
                        }}
                    >
                        {backLabel}
                    </Button>
                </Grid>
            )}
            {!hideNext && (
                <Grid item xs={singleButton ? 12 : 6}>
                    <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<ArrowForwardIosIcon fontSize="small" />}
                        onClick={props.onNext}
                        aria-label={nextAriaLabel}
                        disabled={props.nextDisabled}
                        sx={{
                            borderColor: 'grey.300',
                            color: 'primary.main',
                            py: 2,
                            borderRadius: 2,
                            fontWeight: 'bold',
                            bgcolor: 'white'
                        }}
                    >
                        {nextLabel}
                    </Button>
                </Grid>
            )}
        </Grid>
    );
};
